import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { trackClick } from '../../firebase/analytics';
import { SITE_ORIGIN } from './routes';
import './apps-styles.css';

/**
 * Shared frame for the portfolio section: metadata, breadcrumbs and footer. The
 * skip link and theme toggle live in the app shell (src/App.js), so this
 * layout only owns the section chrome. `theme` switches between the portfolio
 * palette and Birdify's Living Canopy accents. `canonicalPath` must be the
 * exact canonical route. `support` shows the footer's coffee line; pages that
 * make their own contextual offer pass `false`, so a visitor is never asked
 * twice on one screen, and so does the privacy policy, which asks nothing.
 */
export default function AppsLayout({ title, description, canonicalPath, breadcrumbs = [], theme = 'portfolio', page, support: showSupport = true, children }) {
  const canonicalUrl = `${SITE_ORIGIN}${canonicalPath}`;
  return (
    <div className={`apps-page apps-theme-${theme}`}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
      </Helmet>

      <header className="apps-header">
        <Link to="/" className="apps-brand" onClick={trackClick(page, 'brand_home_link')}>
          Keval Langalia
        </Link>
        <nav className="apps-breadcrumbs" aria-label="Breadcrumb">
          <ol>
            <li>
              <Link to="/" onClick={trackClick(page, 'breadcrumb_home_link')}>Home</Link>
            </li>
            {breadcrumbs.map((crumb, index) => {
              const isLast = index === breadcrumbs.length - 1;
              return (
                <li key={crumb.to || crumb.label}>
                  {isLast || !crumb.to ? (
                    <span aria-current={isLast ? 'page' : undefined}>{crumb.label}</span>
                  ) : (
                    <Link to={crumb.to} onClick={trackClick(page, `breadcrumb_${crumb.id || 'link'}`)}>{crumb.label}</Link>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      </header>

      <main id="main" tabIndex={-1}>
        {children}
      </main>
    </div>
  );
}
